export const expertPaymentMethods = [
  { label: "Costo fijo", value: "FIXED_COST" },
  { label: "Horas", value: "HOURS" }
];
